import { ListContent, TextContent } from '@/resource/question/question.type';

const listExample = new ListContent([
  new TextContent('This is the first line'),
  new TextContent('This is the second line'),
  new TextContent('This is the third line'),
  new TextContent('This is the fourth line'),
]);

export default listExample;
